<template>
<div id="add-menu-name">
  <FormGroupHorizontal 
      :label="$t('engine.manageHeader.widgetMenu.AddEditMenu.lblMenuName', languageEngine)"
      :labelHint="languageUse.toUpperCase()"
      :labelRequired="true"
      :split="'4:8'"
      :contentClass="{ errors: validate.$error }"
    >
     <b-form-input
        id="menu-header-name"
        @input="handleInput"
        :value="value"
        :placeholder="$t('engine.manageHeader.widgetMenu.AddEditMenu.lblMenuNameInputPlaceholder', languageEngine)"
      ></b-form-input>
    </FormGroupHorizontal>
  <FormGroupHorizontal v-if="validate.$error"
      :label="''"
      :split="'4:8'"
      class="mt-5"
      :contentClass="'errors'"
    >
      <small v-if="!validate.required && validate.$error"> {{$t('engine.manageHeader.widgetMenu.AddEditMenu.errMenuNameRequired', languageEngine)}} </small>
      <small v-else-if="!validate.maxLength && validate.$error"> {{$t('engine.manageHeader.widgetMenu.AddEditMenu.errMenuNameMaxLength', languageEngine)}} </small>
      <small v-else-if="!validate.alphaName && validate.$error"> {{$t('engine.manageHeader.widgetMenu.AddEditMenu.errMenuNameAlpha', languageEngine)}} </small>
    </FormGroupHorizontal>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import FormGroupHorizontal from '@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal';

export default {
  components: {
    FormGroupHorizontal
  },
  props: {
    value: {
      type: String,
    },
    validate : {
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      languageUse: "design/site/languageUse",
    }),
  },
  methods: {
    handleInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss">
label.required::after {
  margin-left: 5px;
  content:"*";
  color:red;
}
</style>